import request from '@/utils/request';
import authRequest from '@/utils/authRequest';
import { 
  LoginConfigData, 
  AuthorizeRequest, 
  AuthorizeResponse 
} from '@/types/api';

// 获取登录配置
export const getLoginConfig = (poolNo: string): Promise<LoginConfigData> => {
  return request.get('/api/getConfig', { params: { poolNo } });
};

// 获取授权码
export const getAuthorizationCode = (
  data: AuthorizeRequest
): Promise<AuthorizeResponse> => {
  return authRequest.post('/api/oauth2/authorize', data);
};

// 查询用户关联的应用列表
export const getAppList = () => {
  return authRequest.get('/api/userApps');
};

// 查询当前登录用户信息
export const getCurrentUserInfo = () => {
  return authRequest.get('/api/userinfo');
};

// 登出
export const loginOut = () => {
  return authRequest.post('/api/auth/logout', {})
};

// token续期
export const loginRenewal = () => {
  return authRequest.post('/api/oauth2/renewal', {})
};
